import * as React from 'react';
import { Dispatch } from 'redux';
import { CreatedUserViewModel, CreateUserViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as UserNormalizers from '../normalizers/userNormalizers';

export class CreateUserRequest extends BaseApiPostRequest<
  CreateUserViewModel,
  EntityNormalizers.NormalizedSingleEntity<UserNormalizers.NormalizedUsers<CreatedUserViewModel>>
> {
  constructor(createUserFormData: CreateUserViewModel, component: React.Component, dispatch: Dispatch) {
    super(createUserFormData, component, dispatch);
    this.path = `/users`;
    this.normalizeMethod = UserNormalizers.normalizeSingleUser;
  }
}
